import { Chip, Stack } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

export default function ContentFileTabs({
  files = [],
  selectedIndex = 0,
  onSelect,
  disabled = false,
}) {
  if (files.length <= 1) return null;

  return (
    <Stack sx={{ px: 2, pb: 1, flexShrink: 0 }} direction="row" gap={1}>
      <Swiper slidesPerView="auto" spaceBetween={6}>
        {files.map((file, index) => (
          <SwiperSlide key={index} style={{ width: 'auto' }}>
            <Chip
              sx={{
                borderRadius: 2.5,
                backgroundColor:
                  selectedIndex === index ? '#444B53' : undefined,
                color: selectedIndex === index ? '#FFF' : undefined,
                opacity: disabled ? 0.6 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
                '&:hover': {
                  backgroundColor: selectedIndex === index ? '#333' : undefined,
                },
                '& .MuiChip-label': {
                  maxWidth: 160,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
              }}
              label={file.fileName || `파일 ${index + 1}`}
              onClick={() => onSelect?.(index, file.contentOrder)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Stack>
  );
}
